import { Component } from '@angular/core';
import { OrderService } from './services/order.service';
import { OnInit } from '@angular/core';
import {TypeService} from "./services/type.service";
import {Type} from "./model/Type";
import {Router} from '@angular/router';

@Component({
    selector: 'app-admin-manage-types',
    templateUrl: './manage-types.component.html',
    /*styleUrls: ['./app.component.css'],*/
    providers: [TypeService]
})

export class ManageTypesComponent implements OnInit {
    ngOnInit(): void {
        //this.getOrder();
        this.getListTypes();
    }
    title = 'My Order App';

    constructor(private typeService : TypeService,
                private router: Router) {}
    order = null;
    listTypes: Type[];
    //active = false;
    active: any[][] = [];
    editable: boolean[] = [];

    getListTypes(): void {

        this.typeService.getListTypes().then((listTypes) => {
            //console.error("taille dans le app.component = " + listTypes);
            this.listTypes = listTypes;
        }, (error) => {
            console.error(error);
        });

    }

    modifyType(type: Type) : void {
        this.editable[type.id] = true;
    }

    cancelEdit(type: Type) : void {
        this.editable[type.id] = false;
        if(type.id == null) {
            let index = this.listTypes.indexOf(type);
            this.listTypes.splice(index, 1);
        }
    }

    saveType(type: Type) : void {
        if(type.id == null) {
            this.typeService.addType(type).then((result) => {
                this.editable[type.id] = false;
            }, (error) => {
                console.error(error);
            });

        } else {
            this.typeService.modifyType(type).then((result) => {
                this.editable[type.id] = false;
            }, (error) => {
                console.error(error);
            });
        }

    }

    createType() : void {
        let newType = new Type();

        this.listTypes.push(newType);
        this.editable[newType.id] = true;
    }

}



// WEBPACK FOOTER //
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/app/manage-types.component.ts